module.exports = __webpack_public_path__ + "static/media/01_tn.338bf8f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/01_tn.jpg
// module id = 637
// module chunks = 0